import React from 'react';
import PropTypes from 'prop-types';

const SkeletonScreen = ({ isGuestPagePreview = false }) => {
  return (
    <div
      className="skeleton-screen-container"
      aria-hidden="true"
      data-testid="skeleton-screen-container-id"
    >
      <div className="scrim"></div>
      <div className="skeleton-screen-header">
        <div className="skeleton-logo-container">
          <div className="skeleton-logo-radial"></div>
          <div className="skeleton-logo-linear"></div>
        </div>
        <div className="skeleton-link-container">
          <div className="skeleton-link"></div>
          <div className="skeleton-link"></div>
          <div className="skeleton-link"></div>
        </div>
      </div>
      <div className="skeleton-content-container">
        <div className="skeleton-banner"></div>
        <div className="skeleton-content">
          <div className="skeleton-content-left">
            <div className="skeleton-left-photo"></div>
            <div className="skeleton-left-headline"></div>
            <div className="skeleton-left-article"></div>
          </div>
          <div className="skeleton-content-right">
            <div className="skeleton-right-article">
              <div className="skeleton-rt-article-lg"></div>
              <div className="skeleton-rt-articles">
                <div className="skeleton-rt-article"></div>
                <div className="skeleton-rt-article"></div>
                <div className="skeleton-rt-article"></div>
              </div>
            </div>
            <div className="skeleton-right-photo"></div>
            <div className="skeleton-right-headline"></div>
          </div>
        </div>
        <div
          className={`skeleton-banner-bottom ${
            isGuestPagePreview ? 'skeleton-banner-bottom-guest' : ''
          }`}
        ></div>
      </div>
    </div>
  );
};

SkeletonScreen.propTypes = {
  isGuestPagePreview: PropTypes.bool,
};

export default SkeletonScreen;
